import comments from '~/vuex/modules/comments';

export const customModules = {
    comments,
};
